import * as React from "react";
import { withStyles, FormControl } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { emphasize } from "@material-ui/core/styles/colorManipulator";
import ReactSelect2 from "common/components/ReactSelect2";
import { CostPlanStore } from "modules/costPlan/CostPlanStore";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import i18n from "i18n";
import { LoginStore } from "modules/login/LoginStore";

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiInput: {
      underline: {
        "&:after": {
          borderBottom: "2px solid #9aaf00",
        },
      },
    },
  },
});
const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  rowBudget: {
    margin: "1.5rem 0rem",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
  fontBudgetColumn: {
    fontSize: "0.875rem",
    fontWeight: "400" as any,
    lineHeight: "1.43",
    letterSpacing: "0.01071em",
    display: "flex",
    alignItems: "end",
  },
  input: {
    display: "flex",
    padding: 0,
  },
  valueContainer: {
    display: "flex",
    flexWrap: "wrap",
    flex: 1,
    alignItems: "center",
    overflow: "hidden",
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === "light"
        ? theme.palette.grey[300]
        : theme.palette.grey[700],
      0.08
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: "absolute",
    left: 2,
    fontSize: 16,
  },
  divider: {
    height: theme.spacing.unit * 2,
  },
});

type IProps = {
  classes: any;
};

let alphabet: string[] = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

class BudgetColumn extends React.Component<IProps> {
  state = {
    letter: [
      { label: "", value: -1 },
      { label: "", value: -1 },
      { label: "", value: -1 },
      { label: "", value: -1 },
      { label: "", value: -1 },
      { label: "", value: -1 },
      { label: "", value: -1 },
    ],
  };

  componentWillMount(): void {
    let updateFileConfig = LoginStore.userAuth!.updateFileConfig;
    if (updateFileConfig) {
      if (updateFileConfig.properties[6] == undefined) {
        updateFileConfig.properties[6] = { label: "", value: -1 };
      }
    }
  }

  componentDidMount() {
    if (CostPlanStore.arrayObjBudgets.length > 0) {
      CostPlanStore.fillStructCodeColumn =
        CostPlanStore.arrayObjBudgets[0]["value"] != -1 ? true : false;
      CostPlanStore.fillAlternativeCodeColumn =
        CostPlanStore.arrayObjBudgets[1]["value"] != -1 ? true : false;
      CostPlanStore.fillDescriptionColumn =
        CostPlanStore.arrayObjBudgets[2]["value"] != -1 ? true : false;
      CostPlanStore.fillQuantityColumn =
        CostPlanStore.arrayObjBudgets[3]["value"] != -1 ? true : false;
      CostPlanStore.fillCoefficientColumn =
        CostPlanStore.arrayObjBudgets[4]["value"] != -1 ? true : false;
      CostPlanStore.fillUnitColumn =
        CostPlanStore.arrayObjBudgets[5]["value"] != -1 ? true : false;
      CostPlanStore.fillUnitCostColumn =
        CostPlanStore.arrayObjBudgets[6]["value"] != -1 ? true : false;
      this.setState({
        letter: [...CostPlanStore.arrayObjBudgets],
      });
    } else {
      let updateFileConfig = LoginStore.userAuth!.updateFileConfig;
      if (updateFileConfig && updateFileConfig.properties) {
        this.setState({
          letter: [...updateFileConfig.properties],
        });
        if (updateFileConfig.properties[6] == undefined) {
          updateFileConfig.properties[6] = { label: "", value: -1 };
        }

        CostPlanStore.structCodeColumn =
          updateFileConfig.properties[0]["value"];
        CostPlanStore.fillStructCodeColumn =
          updateFileConfig.properties[0]["value"] != -1 ? true : false;

        CostPlanStore.alternativeCodeColumn =
          updateFileConfig.properties[1]["value"];
        CostPlanStore.fillAlternativeCodeColumn =
          updateFileConfig.properties[1]["value"] != -1 ? true : false;

        CostPlanStore.descriptionColumn =
          updateFileConfig.properties[2]["value"];
        CostPlanStore.fillDescriptionColumn =
          updateFileConfig.properties[2]["value"] != -1 ? true : false;

        CostPlanStore.quantityColumn = updateFileConfig.properties[3]["value"];
        CostPlanStore.fillQuantityColumn =
          updateFileConfig.properties[3]["value"] != -1 ? true : false;

        CostPlanStore.coefficientColumn =
          updateFileConfig.properties[4]["value"];
        CostPlanStore.fillCoefficientColumn =
          updateFileConfig.properties[4]["value"] != -1 ? true : false;

        CostPlanStore.unitColumn = updateFileConfig.properties[5]["value"];
        CostPlanStore.fillUnitColumn =
          updateFileConfig.properties[5]["value"] != -1 ? true : false;

        CostPlanStore.unitCostColumn = updateFileConfig.properties[6]["value"];
        CostPlanStore.fillUnitCostColumn =
          updateFileConfig.properties[6]["value"] != -1 ? true : false;

        CostPlanStore.arrayObjBudgets = [...updateFileConfig.properties];
      }
    }
  }

  handleChange = (key, event, type) => {
    let checkedValue;
    if (event === null) {
      event = { value: -1 };
      checkedValue = false;
    } else {
      checkedValue = true;
    }

    if (type === "structCodeColumn") {
      CostPlanStore.fillStructCodeColumn = checkedValue;
      CostPlanStore.structCodeColumn = event.value;
    }

    if (type === "alternativeCodeColumn") {
      CostPlanStore.fillAlternativeCodeColumn = checkedValue;
      CostPlanStore.alternativeCodeColumn = event.value;
    }

    if (type === "descriptionColumn") {
      CostPlanStore.fillDescriptionColumn = checkedValue;
      CostPlanStore.descriptionColumn = event.value;
    }

    if (type === "quantityColumn") {
      CostPlanStore.fillQuantityColumn = checkedValue;
      CostPlanStore.quantityColumn = event.value;
    }

    if (type === "alternativeCodeColumn") {
      CostPlanStore.fillAlternativeColumn = checkedValue;
      CostPlanStore.alternativeColumn = event.value;
    }

    if (type === "unitCostColumn") {
      CostPlanStore.fillUnitCostColumn = checkedValue;
      CostPlanStore.unitCostColumn = event.value;
    }
    if (type === "coefficientColumn") {
      CostPlanStore.fillCoefficientColumn = checkedValue;
      CostPlanStore.coefficientColumn = event.value;
    }

    if (type === "unitColumn") {
      CostPlanStore.fillUnitColumn = checkedValue;
      CostPlanStore.unitColumn = event.value;
    }

    let nameField = type;
    this.state.letter.splice(key, 1, event);
    this.setState({ letter: this.state.letter });
    CostPlanStore.arrayObjBudgets = this.state.letter;
    if (event.label != "") {
      CostPlanStore.setFields(event.label, event.value, nameField);
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <>
        <p
          style={{
            margin: "0.25rem 0rem 1rem",
            fontSize: "0.8rem",
            textAlign: "center",
            fontWeight: "500" as any,
            textTransform: "uppercase",
          }}
        >
          {i18n.wbs.associateColumn}
        </p>

        <Grid className={classes.rowBudget} container>
          <Grid className={classes.fontBudgetColumn} item xs={6}>
            {i18n.wbs.structCode}*
          </Grid>
          <Grid item xs={6}>
            <FormControl className={classes.input}>
              <MuiThemeProvider theme={theme}>
                <ReactSelect2
                  listValues={alphabet}
                  handleChange={(event) =>
                    this.handleChange(0, event, "structCodeColumn")
                  }
                  value={
                    this.state.letter[0].value != -1 ? this.state.letter[0] : ""
                  }
                  placeholder={"Coluna"}
                  boxLine={0}
                  boxType="budgetColumn"
                />
              </MuiThemeProvider>
            </FormControl>
          </Grid>
        </Grid>
        <Grid className={classes.rowBudget} container>
          <Grid className={classes.fontBudgetColumn} item xs={6}>
            {i18n.wbs.alternative}
          </Grid>
          <Grid item xs={6}>
            <FormControl className={classes.input}>
              <MuiThemeProvider theme={theme}>
                <ReactSelect2
                  listValues={alphabet}
                  handleChange={(event) =>
                    this.handleChange(1, event, "alternativeCodeColumn")
                  }
                  value={
                    this.state.letter[1].value != -1 ? this.state.letter[1] : ""
                  }
                  placeholder={"Coluna"}
                  boxLine={1}
                  boxType="budgetColumn"
                />
              </MuiThemeProvider>
            </FormControl>
          </Grid>
        </Grid>
        <Grid className={classes.rowBudget} container>
          <Grid className={classes.fontBudgetColumn} item xs={6}>
            {i18n.wbs.description}*
          </Grid>
          <Grid item xs={6}>
            <FormControl className={classes.input}>
              <MuiThemeProvider theme={theme}>
                <ReactSelect2
                  listValues={alphabet}
                  handleChange={(event) =>
                    this.handleChange(2, event, "descriptionColumn")
                  }
                  value={
                    this.state.letter[2].value != -1 ? this.state.letter[2] : ""
                  }
                  placeholder={"Coluna"}
                  boxLine={2}
                  boxType="budgetColumn"
                />
              </MuiThemeProvider>
            </FormControl>
          </Grid>
        </Grid>
        <Grid className={classes.rowBudget} container>
          <Grid className={classes.fontBudgetColumn} item xs={6}>
            {i18n.wbs.serviceQuantity}
          </Grid>
          <Grid item xs={6}>
            <FormControl className={classes.input}>
              <MuiThemeProvider theme={theme}>
                <ReactSelect2
                  listValues={alphabet}
                  handleChange={(event) =>
                    this.handleChange(3, event, "quantityColumn")
                  }
                  value={
                    this.state.letter[3].value != -1 ? this.state.letter[3] : ""
                  }
                  placeholder={"Coluna"}
                  boxLine={3}
                  boxType="budgetColumn"
                />
              </MuiThemeProvider>
            </FormControl>
          </Grid>
        </Grid>
        <Grid className={classes.rowBudget} container>
          <Grid className={classes.fontBudgetColumn} item xs={6}>
            Coeficiente
          </Grid>
          <Grid item xs={6}>
            <FormControl className={classes.input}>
              <MuiThemeProvider theme={theme}>
                <ReactSelect2
                  listValues={alphabet}
                  handleChange={(event) =>
                    this.handleChange(4, event, "coefficientColumn")
                  }
                  value={
                    this.state.letter[4].value != -1 ? this.state.letter[4] : ""
                  }
                  placeholder={"Coluna"}
                  boxLine={3}
                  boxType="budgetColumn"
                />
              </MuiThemeProvider>
            </FormControl>
          </Grid>
        </Grid>
        <Grid className={classes.rowBudget} container>
          <Grid className={classes.fontBudgetColumn} item xs={6}>
            {i18n.wbs.unit}
          </Grid>
          <Grid item xs={6}>
            <FormControl className={classes.input}>
              <MuiThemeProvider theme={theme}>
                <ReactSelect2
                  listValues={alphabet}
                  handleChange={(event) =>
                    this.handleChange(5, event, "unitColumn")
                  }
                  value={
                    this.state.letter[5].value != -1 ? this.state.letter[5] : ""
                  }
                  placeholder={"Coluna"}
                  boxLine={4}
                  boxType="budgetColumn"
                />
              </MuiThemeProvider>
            </FormControl>
          </Grid>
        </Grid>
        <Grid className={classes.rowBudget} container>
          <Grid className={classes.fontBudgetColumn} item xs={6}>
            {i18n.wbs.unitCost}
          </Grid>
          <Grid item xs={6}>
            <FormControl className={classes.input}>
              <MuiThemeProvider theme={theme}>
                <ReactSelect2
                  listValues={alphabet}
                  handleChange={(event) =>
                    this.handleChange(6, event, "unitCostColumn")
                  }
                  value={
                    this.state.letter[6].value != -1 ? this.state.letter[6] : ""
                  }
                  placeholder={"Coluna"}
                  boxLine={5}
                  boxType="budgetColumn"
                />
              </MuiThemeProvider>
            </FormControl>
          </Grid>
        </Grid>
      </>
    );
  }
}

export default withStyles(styles as any)(BudgetColumn);



// WEBPACK FOOTER //
// ./src/modules/costPlan/components/pages/BudgetColumn.tsx